export default "__VITE_ASSET__1ca71dae__"